/**
 * This Credentials is used to hold the credentials attributes.
*/
export class Credentials {
  public userName: string;
  public password: string;
  public token: string;
  public type: string;

  constructor(userName: string, password: string, token: string, type: string) {
    this.userName = userName;
    this.password = password;
    this.token = token;
    this.type = type;
  }
}
